import { Estacionamiento } from "../../../types/Estacionamiento";
import api from "../../../config/axios";
import { logger } from "../../../utils/logger";

export const fetchEstacionamientos = async (): Promise<Estacionamiento[]> => {
  try {
    logger.debug(
      "🔍 [fetchEstacionamientos] Iniciando petición a /estacionamientos"
    );
    const response = await api.get("/estacionamientos");
    logger.debug(
      "🔍 [fetchEstacionamientos] Respuesta del servidor:",
      response.data
    );
    const estacionamientos = response.data.estacionamientos || [];
    logger.debug(
      "🔍 [fetchEstacionamientos] Estacionamientos extraídos:",
      estacionamientos
    );
    return estacionamientos;
  } catch (error) {
    logger.error(
      "❌ [fetchEstacionamientos] Error fetching estacionamientos:",
      error
    );
    throw error;
  }
};
